import { Stack } from "@mui/system";
import { Html5Qrcode } from "html5-qrcode";
import { useEffect } from "react";

const BarcodeScannerPlugin = ({ onSuccessReadResult, continueScan }) => {
  let html5QrCode;

  useEffect(() => {
    if (!html5QrCode?.getState() && !continueScan) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      html5QrCode = new Html5Qrcode("reader");
      const qrCodeSuccessCallback = (decodedText, decodedResult) => {
        /* handle success */
        onSuccessReadResult(decodedText);
        html5QrCode.pause();
      };
      const onScanFailure = (error) => {
        // setScanError(error);
        //   console.warn(`Code scan error= ${error}`);
      };
      const config = {
        fps: 10,
        qrbox: { width: 250, height: 250 },
      };

      html5QrCode.start(
        { facingMode: "environment" },
        config,
        qrCodeSuccessCallback,
        onScanFailure
      );
    }

    return () => {
      // Anything in here is fired on component unmount.
      // html5QrCode.pause();
    };
  }, [continueScan]);

  return (
    <Stack>
      <div id="reader"></div>
      {/* <Stack>
        <Button onClick={startQR}>Start Camera</Button>
        <Button onClick={stopQR}>Stop Camera</Button>
      </Stack> */}
    </Stack>
  );
};
export default BarcodeScannerPlugin;
